import { Produkt } from "../store/types/organizacje";

export default function getProductData(product: string) {
  if (product === "brunet")
    return {
      type: Produkt.Brunet,
      appName: "brunet",
      appDesc: "Twój księgowy partner",
    };
  else if (product === "faktury")
    return {
      type: Produkt.Zioom,
      appName: "raks",
      appDesc: "\xa0",
    };
  return {};
}
